import type { EstimatableCarrierCode } from '@/services/shipping.service';

export interface ShippingCarrierMeta {
  /** Mã gửi lên BE ở field `shipping_partner`. */
  code: string;
  label: string;
  /**
   * Settings BE có cấu hình được hãng này không. `false` ⇒ hiển thị "Sắp có",
   * KHÔNG dẫn sang trang Settings (ở đó không có gì để bật).
   */
  settingsSupported: boolean;
}

/** Thứ tự hiển thị trong panel chọn ĐVVC — hãng dùng nhiều nhất lên trước. */
export const SHIPPING_CARRIERS: ShippingCarrierMeta[] = [
  { code: 'ghtk', label: 'Giao hàng tiết kiệm', settingsSupported: true },
  { code: 'viettelpost', label: 'Viettel Post', settingsSupported: true },
  { code: 'ahamove', label: 'Ahamove', settingsSupported: true },
  { code: 'ghn', label: 'Giao hàng nhanh', settingsSupported: false },
  { code: 'best', label: 'BEST Express', settingsSupported: true },
  { code: 'jnt', label: 'J&T Express', settingsSupported: false },
  { code: 'spx', label: 'SPX Express', settingsSupported: false },
  { code: 'supership', label: 'SuperShip', settingsSupported: false },
];

/** Nhãn đơn hàng gửi cho ĐVVC. Khớp enum `shipping_label` ở BE DTO. */
export type ShippingOrderLabel = 'fragile' | 'dry_food' | 'delivery' | 'exchange';

export interface ShippingOrderLabelOption {
  value: ShippingOrderLabel;
  label: string;
}

/**
 * Best nhận LOẠI HÀNH TRÌNH (giao / đổi), các hãng khác nhận TÍNH CHẤT HÀNG.
 * Hai bộ khác nghĩa hẳn nhau nên không có nhãn nào dùng chung được.
 */
export const BEST_ORDER_LABELS: ShippingOrderLabelOption[] = [
  { value: 'delivery', label: 'Giao hàng' },
  { value: 'exchange', label: 'Đổi đơn hàng' },
];

export const DEFAULT_ORDER_LABELS: ShippingOrderLabelOption[] = [
  { value: 'fragile', label: 'Dễ vỡ' },
  { value: 'dry_food', label: 'Nông sản, thực phẩm khô' },
];

/** Hãng có adapter ước tính phí ở BE. Khớp `ESTIMATABLE_CARRIER_CODES` trong estimate-fees.dto.ts. */
export const ESTIMATABLE_SHIPPING_CARRIER_CODES: readonly EstimatableCarrierCode[] = [
  'ghtk',
  'best',
];

/**
 * Type guard cho `code: string` bất kỳ (vd `ShippingCarrierMeta.code`) — dùng
 * ở nơi cần biết một mã hãng CÓ nằm trong `ESTIMATABLE_SHIPPING_CARRIER_CODES`
 * hay không mà không phải cast `as EstimatableCarrierCode` ở nơi gọi.
 */
export function isEstimatableCarrierCode(code: string): code is EstimatableCarrierCode {
  return (ESTIMATABLE_SHIPPING_CARRIER_CODES as readonly string[]).includes(code);
}
